import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { Box } from "@mui/material";
import { useGetDepotSynchronizationLogs } from "@api/v1/hooks/useDepotSynchronizationLog";
import { WizardsHeader } from "@components/common/headers/WizardsHeader";
import { WizardLayout } from "@components/common/layouts/WizardLayout";
import { LoadingProgressBar } from "../common/progress/LoadingProgressBar";
import { SynchronizationLogList } from "./SynchronizationLogList";

export const SynchronizationLogListWithRouting = () => {
  const { accountId } = useParams<"accountId">();
  const parsedAccountId = Number.parseInt(accountId!, 10);

  const { data: depotSynchronizationLogList, isFetching } =
    useGetDepotSynchronizationLogs({
      accountId: [parsedAccountId],
      perPage: 10,
      order: "id desc",
    });
  const { t } = useTranslation();

  const goBack = () => {
    window.history.back();
  };

  if (isFetching) {
    return <LoadingProgressBar />;
  }

  return (
    <WizardLayout
      header={
        <>
          <WizardsHeader
            title={t("synchronizationLog.title")}
            onBackClick={goBack}
            variant="dark"
          />
        </>
      }
    >
      <title>{t("synchronizationLog.title")}</title>

      <Box pb={11} width="100%">
        <SynchronizationLogList
          depotSynchronizationLogs={
            depotSynchronizationLogList?.depotSynchronizationLogs || []
          }
        />
      </Box>
    </WizardLayout>
  );
};
